import { useEffect, useState } from "react";
import api from "../api";
import { 
  Table, TableBody, TableCell, TableHead, TableRow, Typography,
  TableContainer, Paper
} from "@mui/material";
import { Link } from "react-router-dom";
import { hubConnection } from "../signalr";
import Heartbeat from "../components/Heartbeat";

export default function Devices() {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    api.get("/device/list").then(res => setDevices(res.data));

    hubConnection.on("deviceCheckIn", (updatedDevice) => {
      setDevices(prev =>
        prev.map(d => d.id === updatedDevice.id ? updatedDevice : d)
      );
    });

    hubConnection.on("deviceEnrolled", (newDevice) => {
      setDevices(prev => [...prev, newDevice]);
    });

    return () => {
      hubConnection.off("deviceCheckIn");
      hubConnection.off("deviceEnrolled");
    };
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4" gutterBottom>
        Devices
      </Typography>

      {/* ⭐ FIX: Wrap table in TableContainer to prevent whitespace nodes */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Device ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Platform</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Last Check-In</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {devices.map(d => (
              <TableRow key={d.id}>
                <TableCell>{d.deviceId}</TableCell>
                <TableCell>{d.name}</TableCell>
                <TableCell>{d.platform}</TableCell>

                <TableCell>
                  <Heartbeat lastCheckIn={d.lastCheckIn} />
                </TableCell>

                <TableCell>
                  {d.lastCheckIn
                    ? new Date(d.lastCheckIn).toLocaleString()
                    : "Never"}
                </TableCell>

                <TableCell>
                  <Link to={`/devices/${d.deviceId}`}>View</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
